/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_line_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online line chart maker. Paste your data as CSV or columns and get an instant, colourful line chart to visualise trends.`)
};

const es_line_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador gratuito de gráficos de líneas online. Pega tus datos como CSV o columnas y obtén un gráfico de líneas instantáneo y colorido para visualizar tendencias.`)
};

const de_line_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Liniendiagramm-Ersteller. Fügen Sie Ihre Daten als CSV oder Spalten ein und erhalten Sie sofort ein farbenfrohes Liniendiagramm zur Visualisierung von Trends.`)
};

const nl_line_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online lijndiagrammaker. Plak je data als CSV of kolommen en krijg direct een kleurrijk lijndiagram om trends te visualiseren.`)
};

const fr_line_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur gratuit de graphique en courbes en ligne. Collez vos données en CSV ou en colonnes et obtenez instantanément un graphique en courbes coloré pour visualiser les tendances.`)
};

const it_line_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore gratuito di grafici a linee online. Incolla i tuoi dati come CSV o colonne e ottieni un grafico a linee istantaneo e colorato per visualizzare le tendenze.`)
};

const pt_br2_line_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador gratuito online de gráfico de linhas. Cole seus dados como CSV ou colunas e obtenha um gráfico de linhas instantâneo e colorido para visualizar tendências.`)
};

const pt_line_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador gratuito de gráficos de linhas online. Cole os seus dados em CSV ou colunas e obtenha instantaneamente um gráfico de linhas colorido para visualizar tendências.`)
};

const ja_line_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンライン折れ線グラフ作成ツール。データをCSVまたは列として貼り付けると、傾向を可視化する見やすい折れ線グラフが即座に得られます。`)
};

const zh_line_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线折线图制作工具。将数据以 CSV 或列的形式粘贴，即可获得即时的多彩折线图以可视化趋势。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const line_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.line_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("line_meta_description", locale)
	if (locale === "en") return en_line_meta_description(inputs)
	if (locale === "es") return es_line_meta_description(inputs)
	if (locale === "de") return de_line_meta_description(inputs)
	if (locale === "nl") return nl_line_meta_description(inputs)
	if (locale === "fr") return fr_line_meta_description(inputs)
	if (locale === "it") return it_line_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_line_meta_description(inputs)
	if (locale === "pt") return pt_line_meta_description(inputs)
	if (locale === "ja") return ja_line_meta_description(inputs)
	return zh_line_meta_description(inputs)
};